import styled from "styled-components";

export const Container = styled.header`
  margin-bottom: 20px;

  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 1.5rem;
    display: flex;
    align-items: center;
  }

  .arrowBack {
    display: flex;
    justify-content: center;
    align-items: center;

    margin-right: 10px;

    height: 30px;
    width: 30px;

    border-radius: 50%;

    transition: all 0.4s;

    &:hover {
      background-color: #ccc;
    }
  }

  .infoUpdate {
    span {
      font-size: 0.8rem;
      color: #555;
      font-weight: 300;
    }
  }

  .actions-container {
    position: relative;
  }

  .actions {
    position: absolute;
    right: 0;
    border: 1px solid #ddd;
    border-radius: 6px;

    z-index: 10;

    display: flex;
    flex-direction: column;

    background-color: #fff;
    width: 15rem;

    .actionButton {
      display: flex;
      align-items: center;
      gap: 5px;

      padding: 0.5rem 1rem;

      background-color: #fff;

      font-size: 0.875rem;
      font-weight: bold;

      border-radius: 6px;
      border-bottom: 1px solid #ddd;

      color: #333;

      transition: all 0.3s;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #ddd;
        cursor: pointer;
      }
    }

    .actionButton svg {
      width: 1.8rem;
      height: 1.8rem;
    }
  }
`;
